// import Alert from "./Alert";
import Certification from "./CertificationIcon";
import { useTranslation } from "react-i18next";

function Section02({ config }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const getImagePath = (imageName) => {
    return `${process.env.PUBLIC_URL}/images/${currentLanguage}/${imageName}`;
  }
  return (
    <div>
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight text-modern-primary">
                  <div className="mr-4">
                    <Certification sizeNum="3.5" />
                  </div>
                  {t('資格情報のお知らせで確認')}
                </h2>
              </div>
            )}

           <p> {t('「資格情報のお知らせ」は入社や転職で社会保険の資格を取得したときや被扶養者になったときに発行されます。')}
            {t('なお、この通知書だけでは保険診療を受けることはできないため、マイナンバーカードと併せて持参する必要があります。')}</p>

            <figure className="flex flex-col justify-center items-center">
              <img
                className="w-full border object-cover shadow-lg"
                src={getImagePath('oshirase2.png')}
                alt={t('資格情報のお知らせのサンプル')}
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                {t('ご加入の健康保険組合により記載内容が異なる場合があります。')}
              </figcaption>
            </figure>

            <div className="hidden space-y-8">
              <h3 className="text-2xl font-semibold mt-16">
                {t('資格情報のお知らせ（個人番号下四桁記載なし）')}
              </h3>
            </div>

            <figure className="hidden flex flex-col justify-center items-center">
              <img
                className="w-full object-cover shadow-md"
                src={getImagePath('oshirase.png')}
                alt={t('資格情報のお知らせのサンプル')}
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                {t('ご加入の健康保険組合によりデザインや記載内容が異なる場合があります。')}
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section02;
